import { Component } from 'react';
import { connect } from 'react-redux';

import Slider from 'rc-slider';
import { RootState } from 'types';
import { translate } from 'utils/translate';

interface ValueSliderProps {
    className?: string;

    name: string;
    label: string;
    unit: string;

    value: number;
    range: number[];
    decimal: number;
    onChange?: (name: string, value: number) => void;

    language?: string;
    disabled?: boolean;
    isValid?: boolean;
}

interface ValueSliderState {
    language: string;
    value: number;
}

class ValueSlider extends Component<ValueSliderProps, ValueSliderState> {
    constructor(props: ValueSliderProps) {
        super(props);
        this.state = {
            language: 'en',
            value: 0,
        };
    }

    static getDerivedStateFromProps(props: ValueSliderProps, state: ValueSliderState) {
        if ((props.language !== state.language, props.value !== state.value)) {
            return {
                language: props.language,
                value: props.value,
            };
        }
        return null;
    }

    componentDidMount(): void {
        this.setState({ value: this.props.value });
    }

    handleChange = (updatedValue: number) => {
        if (this.props.disabled || !this.props?.onChange) {
            return false;
        }

        const { name, onChange, decimal } = this.props;

        updatedValue = parseFloat(updatedValue.toFixed(decimal));

        onChange?.(name, updatedValue);
    };

    render() {
        const { label, unit, range, decimal } = this.props;

        return (
            <div className="  mb-5 w-full no-select ">
                <div className="block font-medium leading-5 text-gray-700   ">
                    <span className="capitalize">{label} </span>({unit}) :
                    <span className="cursor-pointer mx-1 underline  text-blue-700 lowercase  hover:text-blue-800 ">
                        {this.state.value === range[0]
                            ? translate('min')
                            : this.state.value === range[1]
                            ? translate('max')
                            : this.state.value}
                    </span>
                </div>
                <Slider
                    className="mr-3 ml-1 w-auto"
                    step={Math.pow(10, -decimal)}
                    allowCross={false}
                    disabled={this.props.disabled}
                    min={range[0]}
                    max={range[1]}
                    marks={{
                        [this.state.value]: <strong className="text-sm">{this.state.value}</strong>,
                    }}
                    value={this.state.value}
                    onChange={(updatedValue) => {
                        // @ts-ignore
                        this.handleChange(updatedValue);
                    }}
                    onChangeComplete={() => {
                        // @ts-ignore
                        this.handleChange(this.state.value);
                    }}
                />
            </div>
        );
    }
}

const valueSliderStateToProps = (state: RootState) => ({
    language: state.user.language,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const valueSliderDispatchToProps = () => ({});

export default connect(valueSliderStateToProps, valueSliderDispatchToProps)(ValueSlider);
